import { render } from "./NotFound.vue?vue&type=template&id=5b082c0d"
const script = {}
script.render = render

export default script